import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            key: page.title
          }, [
            _createElementVNode("a", {
              href: page.link,
              target: "_blank"
            }, _toDisplayString(page.title), 9, _hoisted_2)
          ]))
        }), 128))
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("small", { class: "copyright" }, "Copyright © USEN CORPORATION All Right Reserved.", -1))
    ])
  ]))
}